import { InputLabel, TextField } from '@mui/material'
import styled from 'styled-components'
import { COLORS, FONTS, TYPOGRAPHY } from 'utils'

export interface InputStyles {
  marginTop?: string
  marginBottom?: string
  marginLeft?: string
  marginRight?: string
  width?: string
  hasError?: boolean
}

export const CustomInput = styled(TextField) <InputStyles>`
  && {
    margin-top: ${({ marginTop }) => marginTop};
    margin-bottom: ${({ marginBottom }) => marginBottom};
    margin-left: ${({ marginLeft }) => marginLeft};
    margin-right: ${({ marginRight }) => marginRight};
    width: ${({ width }) => width || '100%'};

    border: none;
  }

  .MuiInputBase-root:before {
    border-bottom: 0.1rem solid
      ${({ hasError }) => (hasError ? COLORS.error : COLORS.black)};
  }
  .MuiInputBase-root:after {
    border-bottom: 0.1rem solid
      ${({ hasError }) => (hasError ? COLORS.error : COLORS.blueFonts)};
  }

  .MuiInput-underline:hover:before {
    border-bottom: 0.1rem solid
      ${({ hasError }) => (hasError ? COLORS.error : COLORS.blueFonts)};
  }
`

export const InputLabelCustom = styled(InputLabel) <InputStyles>`
  font-size: ${TYPOGRAPHY.bodySize14};
  font-weight: ${FONTS.regular};
  color: ${({ hasError }) => (hasError ? COLORS.error : COLORS.black)};
  font-family: Arial;
`
